import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDuQC_zbawMSKhMjQuBTXm46UYcxnH_cgc",
  authDomain: "cannabis-delivery-platform.firebaseapp.com",
  projectId: "cannabis-delivery-platform",
  storageBucket: "cannabis-delivery-platform.firebasestorage.app",
  messagingSenderId: "279981110833",
  appId: "1:279981110833:web:352da706d37718ddd08710"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);